<template>
  <div class="boyindex">
    <div class='main'>
      <div style="margin-bottom: 10px;font-size: 24px;width: 100%;text-align: center;color: #fff;font-weight: 600">
        登录中心
      </div>
      <div class="item">
        <van-field v-model="username" style="font-size: 18px!important;border-radius: 10px"   placeholder="请输入用户账号" />
      </div>
      <!--          <input class="phone" v-model="username" type="text" placeholder="请输入用户账号">-->
      <div class="item">
        <van-field v-model="password" type="password" style="font-size: 18px!important;border-radius: 10px" placeholder="请输入密码"/>
      </div>
      <!--          <input class="password" v-model="password" :type="showPasswordFlag?'text':'password'" placeholder="请输入密码">-->
      <!--          <input class="captcha" v-model="captcha" type="text" placeholder="请输入验证码" maxlength="6" v-on:keyup.enter="onEnter">-->
      <div class="item" style="display: flex;">
        <van-field v-model="captcha"  placeholder="请输入验证码" style="font-size: 18px!important;border-top-left-radius: 10px;border-bottom-left-radius: 10px"/>
        <img class="getImgCaptcha" :src="imgCaptcha" @click="getImgCaptcha" style="border-top-right-radius: 10px;border-bottom-right-radius: 10px" alt="">
      </div>
      <!--<p class="desc" v-if="errorText">{{errorText}}</p>-->
      <!--      <p class="submitBtn" @click="submit">立即登录</p>-->
      <div style="width: 100%;text-align: center;margin-top: 20px">
        <van-button style="border-radius: 10px;font-size: 18px" type="primary" @click="submit">立即登录</van-button>
      </div>
    </div>
  </div>
</template>

<script >
import {Config} from "../../components/common/api";
export default {
  name: "login",
  data() {
    return {
      userRole: '0', // 用户角色 0 用户登录  1 后台登录
      showModal: false,
      loading: false,
      phone: "",
      captcha: "",
      password: "",
      ajaxState: true, // 防止重复提交，调用多次接口
      captchaAjaxState: true, // 验证码防止重复提交，调用多次接口
      isShow: false, // 验证码校验成功时展示成功标识
      buttonText: "获取验证码",
      showImg: 1,
      count: 60,
      agreeState: false, // 是否同意协议
      captchaUrl: '', // 滑块验证码图片链接
      ticket: '', // 滑块验证码ticket
      showPasswordFlag: false, // 是否展示密码
      loginType: '1', // 登录方式： 0 短信验证码登录   1 密码登录
      errorText: '',
      token: '', // 登录缓存
      imgCaptcha: '', // 图形验证码URL
      codeKey: '', // 图形验证码codeKey
      username: ''// 用户账号
    };
  },
  mounted() {
    this.resize();
    document.getElementsByTagName('title')[0].innerText = '登录';
    this.userRole = this.$route.query.role || '0';
    this.getImgCaptcha();
  },
  methods: {
    onEnter:function(){
      this.submit();
    },
    resize: function () {
      const _width = this.getPageWidth();
      const ratio = _width / 1980;
      const curWidth = 16 * ratio;
      document.getElementsByTagName('html')[0].style.fontSize = curWidth + "px";
    },
    getPageWidth() {
      const g = document,
        a = g.body,
        f = g.documentElement,
        d = g.compatMode == "BackCompat" ? a : g.documentElement;
      return Math.max(f.scrollWidth, a.scrollWidth, d.clientWidth);
    },
    // 同意协议
    toAgree() {
      this.agreeState = !this.agreeState;
    },
    // 电话号码格式校验
    checkMobiles(number) {
      return /^((13|15|18|14|17|16|19)+\d{9})$/.test(number);
    },
    checkPhone(number) {
      if (number.trim() === "") {
        this.$message({
          type: "error",
          message: '请填写手机号码',
          offset: 300
        });
        return false;
      } else if (!this.checkMobiles(number)) {
        this.$message({
          type: "error",
          message: '您的手机号码格式有误，请重新输入',
          offset: 300
        });
        return false;
      }
      return true;
    },
    // 发送验证码接口
    sendMessage() {
      if (!this.checkPhone(this.phone)) {
        return;
      }
      const self = this;
      if (this.captchaAjaxState) {
        this.captchaAjaxState = false;
        this.$ajax({
          method: "post",
          url: Config.api_url + "user/message/send",
          params: {
            MESSAGE_PARAM: {"PHONE_NUMBER": this.phone}
          }
        }).then(res => {
          const data = res.data;
          if (data.CODE === '0000') {
            let count = 60;
            const setYzm = setInterval(() => {
              if (count === 0) {
                clearInterval(setYzm);
                self.buttonText = "重新获取";
                count = 60;
                self.captchaAjaxState = true;
              } else {
                self.buttonText = count + "s后重新获取";
                count -= 1;
              }
            }, 1000);
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 300
            });
            self.captchaAjaxState = true;
          }
        }).catch(err => {
          self.$message({
            type: "error",
            message: '网络异常，请重试',
            offset: 300
          });
          self.captchaAjaxState = true;
        });
      }
    },
    // 获取图形验证码
    getImgCaptcha() {
      const self = this;
      if (this.captchaAjaxState) {
        this.captchaAjaxState = false;
        this.$ajax({
          method: "get",
          url: Config.api_url + "applets-server/api/image/captcha",
          params: {
          }
        }).then(res => {
          self.captchaAjaxState = true;
          const data = res.data;
          if (data.success) {
            self.imgCaptcha = data.data.image;
            self.codeKey = data.data.codeKey;
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 300
            });
          }
        }).catch(err => {
          self.$message({
            type: "error",
            message: '网络异常，请重试',
            offset: 300
          });
          self.captchaAjaxState = true;
        });
      }
    },
    // 登录
    submit() {
      let self = this;
      if (this.username == '') {
        this.$message({
          type: "error",
          message: '请正确填写账号',
          offset: 300
        });
        return false;
      }
      if (this.captcha == '') {
        this.$message({
          type: "error",
          message: '请正确填写验证码',
          offset: 300
        });
        return false;
      }

      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      const url = Config.api_url + "applets-server/api/login/account";
      // this.$refs.loading.loadingFlag = true;
      let param = {
        type: 'account',
        username: this.username,
        codeVal: this.captcha,
        codeKey: this.codeKey
      };
      if (this.loginType === '0') { // 短信验证码登录
        param.CAPTCHA = this.captcha;
      } else {
        param.password = this.password;
      }
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          ...param
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.ajaxState = true;
        const data = res.data;
        if (data.success) {
          self.$message({
            type: "success",
            message: '登录成功',
            offset: 300,
            duration: 2000
          });
          const userInfo = {
            name: data.data.name,
            currentAuthority: data.data.currentAuthority,
            type: "account",
            insuredId: data.data. insuredId
          };
          localStorage.setItem('localUserInfo', JSON.stringify(userInfo));
          localStorage.setItem('token', data.data.accessToken);
          localStorage.setItem('needReload', '1');
          setTimeout(() => {
            self.$router.push('/checkType');
            // self.$router.push('/myOrders');
          }, 1000)
        } else {
          self.getImgCaptcha();
          self.$message({
            type: "error",
            message: data.errorMessage,
            offset: 300
          });
        }
        // self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.$message({
          type: "error",
          message: '网络异常，请重试',
          offset: 300
        });
        self.ajaxState = true;
        // self.$refs.loading.loadingFlag = false;
        self.getImgCaptcha();
      });
    },
    // 查看协议
    toRule(type) {
      this.$router.push(`/rule?type=${type}`);
    },
    // 去注册
    toRegister() {
      this.$router.push('register');
    },
  },
  watch: {
    phone() {
      this.phone = this.phone.replace(/[^0-9]+/, '')
    },
    /* captcha() {
       this.captcha = this.captcha.replace(/[^0-9]+/, '')
     },*/
  },
};
</script>

<style lang="scss" scoped>
.boyindex{
  /* 使用线性渐变作为背景，方向从上到下（默认方向），从一种颜色渐变到另一种颜色 */
  background: linear-gradient(to bottom, #0C6DF0, #CDE1FA);
  /* 为了更好地展示渐变效果，可以设置元素的高度和宽度 */
  height: 100vh; /* 占满整个视口高度 */
  width: 100%; /* 占满父级元素的宽度 */
}
.main{
  //background: red;
  padding: 20px;
  width: 80%;
  margin: auto;
  padding-top: 50%;
  //box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.1);
}
.item{
  margin-bottom: 15px;
  font-size: 18px!important;

}
::v-deep .van-field__control{
  font-size: 18px!important;
}
</style>



// WEBPACK FOOTER //
// login.vue?267b5cfe